import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { DOData, DocdefDataVM, NJDocData, NJDocDefTemplate, componentVM } from "../DOData";
import { DocDefPrimLibService } from '../../doc-def-prim-lib.service';

@Component({
    selector: 'cylib-dotext-box-sgl',
    templateUrl: './dotext-box-sgl.component.html',
    styleUrls: ['./dotext-box-sgl.component.css']
})

export class DotextBoxSglComponent implements OnInit {
    @Input() DocDefTemplate: NJDocDefTemplate
    @Input() loaderKey: string;
    private _docData: NJDocData;
    @Input() skipPostDocDefData: boolean;
    @Input() set DocData(doData: NJDocData) {
        this._docData = doData;
        this.txtDocData = this.DocData;
        this.txtValue =  this._docData.dataValue;
    }
    get DocData(): NJDocData {
        return this._docData;
    }
    @Input() customParameters: any;
    @Input() ignorLabel: boolean = false;
    @Input() isValid: boolean;
    @Input() RowSelected: any;

    private _isEnabled: boolean = true;
    TextBoxStyles: any;
    @Input() public set isEnabled(t: boolean) {
        this._isEnabled = t;
    }
    public get isEnabled(): boolean {
        return this._isEnabled;
    }

    @Output() clickBut: EventEmitter<DOData> = new EventEmitter<DOData>();
    labelClass(): string {
        if (this.customParameters['LabelWidth'] == null) {
            return "col-md-6 col-sm-6";
        } else {
            return this.customParameters['LabelWidth'];
        }
    }
    public _isDirty: boolean = false
    public set isDirty(t: boolean) {
        this._isDirty = t;
    }
    public get isDirty(): boolean {
        return this._isDirty;
    }
    isLoading: boolean = false;
    //use for zip code field
    @Input() public hasEvent: boolean = false;
    //used to avoid race condition caused by onblur updating loader. Caller will reset hasEvent before update completed.
    // fireEventBefore and fireEventAfter fires before and after
    // fireEventBefore only before
    // hasEvent only after
    localhasEvent: boolean;
    localEventFired: boolean=false;
    txtDocData: NJDocData;
    txtDocDefTemplate: NJDocDefTemplate;
    errorMessage: string;
    LabelStylesText: any

    isReadOnly: boolean = false;
    private onKeydownKey: any;
    inputType: string = "";
    placeholder: string = "";
    MaxLength: string = "8000";
    TextBoxStyle: any;
    isLabelHidden: boolean = false;
    public isHidden: boolean = false;
    public isDeactivateDirty:boolean= false;

    constructor(private data: DocDefPrimLibService, private changeDetectorRef: ChangeDetectorRef) { }

    get txtValue(): string {
        if (this.customParameters.ValueToBlank != null) {
            if (this.txtDocData.dataValue == this.customParameters.ValueToBlank)
                this.txtDocData.dataValue = "";
        }
       
        return this.txtDocData.dataValue;
    }
    set txtValue(TxtValue: string) {
        if (!this.isLoading) {
            if (this.txtDocData.dataValue != TxtValue) {
                this.txtDocData.dataValue = TxtValue;
                if (this.customParameters.isPhone != null) {
                    TxtValue = this.fmtPhone(TxtValue);
                    this.txtDocData.dataValue = TxtValue;
                }
                if (this.customParameters.isSSN != null) 
                {
                    TxtValue = this.fmtSSN(TxtValue);
                    this.txtDocData.dataValue = TxtValue;
                }
                if (this.customParameters.isNumeric != null) {
                    TxtValue = this.NumericOnly(TxtValue);
                    this.txtDocData.dataValue = TxtValue;
                }
                this.isDirty = true;
                this.localEventFired = false;
            }
        }
    }
    onKeydown(event) {
        if (this.hasEvent) {
            //this.isDirty = true;
            this.onKeydownKey = event.key;
            this.onBlurText();
        }
    }

    private formatMaskedSSN(value): string {
        var ssn: string = value.trim();
        if (ssn.startsWith("XXX-XX-"))  // Already formatted
            return ssn;
        if (ssn.length == 0)   // Blank ssn
            return "";
        if (ssn.length == 11)  // ssn format: "999-99-9999"
            return ssn = "XXX-XX-" + ssn.substring(7, value.length);  // masked ssn
        if (ssn.length == 9)  // ssn format: "999999999"
            return ssn = "XXX-XX-" + ssn.substring(5, value.length);  // masked ssn
        // Otherwise ssn is invalid
        return "XXX-XX-XXXX";
    }

    private fmtSSN(value): string {
        if (this.customParameters.ssnFmt == "MaskedAllButLast4")
            return this.formatMaskedSSN(value);
        else { 
            var val = value.replace(/\D/g, '');
            val = val.replace(/^(\d{3})/, '$1-');
            val = val.replace(/-(\d{2})/, '-$1-');
            val = val.replace(/(\d)-(\d{4}).*/, '$1-$2');

            // Works for existing data but not for when you are entering it.
            //if (this.customParameters.ssnFmt == "MaskedAllButLast4" && value)
            //    val = "XXX-XX-" + val.substring(val.length - 4);

            return val == "" ? value : val;
        }
    }

    private fmtPhone(value): string {
        var lenDiff = value.length;
        if (this.txtDocDefTemplate.templateCode == 'WP_002_PROVDET_WP_002_PROVDET__TOSection_ProviderDetails_TextBoxSng_Phone1' || this.txtDocDefTemplate.templateCode == 'WP_002_PROVDET_WP_002_PROVDET__TOSection_ProviderDetails_TextBoxSng_Phone2') { //ALM-32796
            if (value.startsWith('1')) {
                var x = value.replace(/\D/g, '').match(/(\d{0,1})(\d{0,3})(\d{0,3})(\d{0,4})/);
                value = !x[3] ? x[1] + x[2] : '1 (' + x[2] + ') ' + x[3] + (x[4] ? '-' + x[4] : '');
            } else {
                var x = value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
                value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
            }
        } else {
            var x = value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
            value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
            //if junk was typed in then the above code will strip it out, but we need to create a new string to override the junk.
            if (lenDiff - value.length > 0) {
                value = new String(value);
            }
        }
        return value;
    }
    private NumericOnly(value): string {
        var lenDiff = value.length;
        value = value.replace(/\D+/g, '');
        //if junk was typed in then the above code will strip it out, but we need to create a new string to override the junk.
        if (lenDiff - value.length > 0) {
            value = new String(value);
        }
        return value;
    }

    ngOnInit() {
        if (this.customParameters['isEnabled'] == 'False')
            this.isEnabled = false;
        if (this.customParameters['LabelStylesText'] != null) {
            let styles = this.data.replaceAll(this.customParameters['LabelStylesText'], "'", '"');
            this.LabelStylesText = JSON.parse(styles);
        }

        this.txtDocDefTemplate = this.DocDefTemplate;
        this.txtDocData = this.DocData;

        if (this.customParameters.isPhone != null && this.txtDocData.dataValue != null) {
            this.txtDocData.dataValue = this.fmtPhone(this.txtDocData.dataValue);
        }
        if (this.customParameters.isSSN != null && !this.txtDocData.dataValue.startsWith("XXX-XX-")) {
            this.MaxLength = "11";
            this.txtDocData.dataValue = this.fmtSSN(this.txtDocData.dataValue);
        }
        if (this.customParameters.isZipCode != null) {
            this.MaxLength = "10";
        }
        this.txtValue = this.txtDocData.dataValue;
        if (this.customParameters['isLabelHidden'] != null)
            if (this.customParameters['isLabelHidden'].toUpperCase() === 'TRUE')
                this.isLabelHidden = true;
        this.setHiddenStatus();
    }
    setHiddenStatus() {
        if (this.customParameters.Hidden == 'Yes')
            this.isHidden = true;
        //is the the required seccode in the user's credentials
        else if (this.customParameters["HiddenIfMissingSecCode"]) {
            //this.data.checkIfCodeInUserSecurity(this.customParameters["HiddenIfMissingSecCode"]).subscribe((ret: boolean) => {
            //    if (ret) {
            //        this.isHidden = false;
            //    }
            //    else {
            //        this.isHidden = true;
            //    }
            //        });
        }
        else this.isHidden = false;
    }
    IsFormGroup() {
        if (this.customParameters['FormGroupItem'] == 'Yes')
            return "form-group flex-nowrap";
        else
            return "";
    }
    classFromParams() {
        let ret: string = "";
        if (this.customParameters.DisabledStyle == 'Yes') {
            ret = "input-block-level";
        }
        else if (this.customParameters.DisabledStyle == 'No') {
            ret = "input-block-level-white";
        }
        if (this.customParameters['InputClass'] != null) {
            ret = ret + " " + this.customParameters['InputClass']; //form-control
        }
        return ret;
    }
    getTextStyle(): object {
        if (this.customParameters['TextBoxStyle'] != null) {
            let styles = this.data.replaceAll(this.customParameters['TextBoxStyle'], "'", '"');
            this.TextBoxStyle = JSON.parse(styles);
            if (this.isValid)
                if (this.RowSelected) {
                    if (this.RowSelected['background-color'] == "lightsteelblue") {
                        this.TextBoxStyle['background-color'] = "lightsteelblue";
                        return this.TextBoxStyle;
                    }
                }
                else if (this.isReadOnly == true) {
                    this.TextBoxStyle['background-color'] = "white";
                    return this.TextBoxStyle;
                }
                else {
                    return this.TextBoxStyle;
                }
            else {
                    this.TextBoxStyle['background-color'] = "lightpink";
                    return this.TextBoxStyle;
                }
        }
        else {
            if (this.isValid)
                return null
            else
            {
                return { "background-color": "lightpink" };
            }
        }
    }
    ngOnChanges(): void {
        this.isLoading = true;

        this.txtDocDefTemplate  = this.DocDefTemplate;
        this.txtDocData = this.DocData;

        if (this.customParameters.isPhone != null && this.txtDocData.dataValue != null) {
            this.txtDocData.dataValue = this.fmtPhone(this.txtDocData.dataValue);
        }

        if (this.customParameters.isSSN != null && !this.txtDocData.dataValue.startsWith("XXX-XX-")) {
            this.txtDocData.dataValue = this.fmtSSN(this.txtDocData.dataValue);
        }
        this.txtValue = this.txtDocData.dataValue;

        if (this.customParameters['TextValue'] != null) {
            this.isLoading = false;
            this.txtDocData.dataValue = this.customParameters['TextValue'];
            this.txtValue = this.txtDocData.dataValue;
        }
        this.isLoading = false;
        if (this.customParameters['TextBoxStyles'] != null) {
            let styles = this.data.replaceAll(this.customParameters['TextBoxStyles'], "'", '"');
            this.TextBoxStyles = JSON.parse(styles);
        }
        if (this.customParameters['hasEvent'] == 'Yes')
            this.hasEvent = true;
        if (this.customParameters['inputType'])
            this.inputType = this.customParameters['inputType']
        else
            this.inputType = 'text';
        if (this.customParameters['placeholder'])
            this.placeholder = this.customParameters['placeholder']
        else
            this.placeholder = '';
    }
    clearTextbox() {
        this.txtDocData.dataValue = "";
        this.isDirty = true;
        this.onBlurText();
    }
    setTextToValue(value: string) {
        this.txtDocData.dataValue = value;
        this.isDirty = true;
        this.onBlurText();
    }
    onBlurText() {
        this.changeDetectorRef.detectChanges();
        if (this.customParameters.fireEventBefore) {
            this.localhasEvent = false;
            if (this.hasEvent) {
                let DOMessage: DOData = new DOData();
                DOMessage.njDocData = this.DocData;
                this.DocDefTemplate.indent = this.onKeydownKey;
                DOMessage.njDocDefTemplate = this.DocDefTemplate;
                this.onKeydownKey = "";
                if (!this.localEventFired)
                    this.clickBut.emit(DOMessage);
                this.localEventFired = true;
            }
        } else {
            this.localhasEvent = this.hasEvent;
        }
        this.isDeactivateDirty = true;
        //Made this change to bypass the PostDocDefData calls in AddNewYouth controls
        if ((this.customParameters.skipPostDocDefData == "True" || this.skipPostDocDefData == true) && this.customParameters.DontskipPostDocDefData != "True") {
            return this.onSaveComplete();
        }
        else {
            if (!this.isLoading && this.isDirty) {
                let lstDocData: DocdefDataVM = new DocdefDataVM();
                lstDocData.docdata.push(this.txtDocData);
                lstDocData.loaderKey = this.loaderKey;
                var _this = this;
                this.data.saveDocDefData(lstDocData)
                    .subscribe(function () {
                        _this.isDirty = false;
                        return _this.onSaveComplete();
                    }, function (error) {
                        _this.isDirty = false;
                        return _this.errorMessage = error;
                    });
            }
        }
    }
    evCallBackWhenClean: DOData;
    evComponent: any
    CallBackWhenClean(ev, component) {
        this.evCallBackWhenClean = ev;
        this.evComponent = component;
    }
    onSaveComplete = function () {
        if (this.evCallBackWhenClean) {
            let ev = DocDefPrimLibService.createNew(this.evCallBackWhenClean);
            this.evComponent.onClickButton(ev);
            this.evCallBackWhenClean = null;
        } else {
            if (this.customParameters.fireEventAfter) {
                this.localhasEvent = true;
            }
            if (this.localhasEvent) {
                let DOMessage: DOData = new DOData();
                DOMessage.njDocData = this.DocData;
                this.DocDefTemplate.indent = this.onKeydownKey;
                DOMessage.njDocDefTemplate = this.DocDefTemplate;
                this.onKeydownKey = "";
                if (!this.localEventFired)
                    this.clickBut.emit(DOMessage);
                this.localEventFired = true;
            }
        }
    }
}
